import { useLocalBoolean } from '@silae/composables';

const {
	value: isMobileAppBannerClosed,
	toggle: dismissMobileAppBanner,
	disable: showMobileAppBanner
} = useLocalBoolean('my-silae-mobile-app-banner-is-closed');

export { dismissMobileAppBanner, showMobileAppBanner, isMobileAppBannerClosed };
